import React, { useState, useCallback, useEffect } from "react";

// Bootstrap imports
import {
  Row,
  Col,
  Button,
  ButtonGroup,
  Form,
  ListGroup,
} from "react-bootstrap";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import DropdownButton from "react-bootstrap/DropdownButton";
import Dropdown from "react-bootstrap/Dropdown";
import * as Icon from "react-bootstrap-icons";
import { ReportGrid } from "../ReportGrid";

// external libraries
import { ThreeCircles } from "react-loader-spinner";

// custom imports
import { getFromLS, setToLS } from "../../../utils/storage";
import { logout } from "../../../utils";
import { NoAccessPopup } from "../../../reusable-components/NoAccessPopupComponent/NoAccessModal";

// highchart imports
import * as Highcharts from "highcharts/highstock";
import drilldown from "highcharts/modules/drilldown";
import HighchartsReact from "highcharts-react-official";
import * as HighchartsExporting from "highcharts/modules/exporting";
import { TemplateDownloadRenderer } from "../TemplateDownloadRenderer";
import DropFileInput from "../../../reusable-components/DropFileComponent/DropFileComponent";
import OffCanvasNavbar from '../reportNavbar'
import { TemplateDescriptionPopover } from "../TemplatePopoverlay";
require("highcharts/modules/accessibility")(Highcharts);
drilldown(Highcharts);
HighchartsExporting(Highcharts);
// Highcharts text formatter
Highcharts.setOptions({
  lang: {
    thousandsSep: ",",
  },
});
const Switch = ({ isToggled, onClick }) => {
  return (
    <label className="switch">
      <input type="checkbox" checked={isToggled} onChange={onClick} />
      <span className="slider round"></span>
    </label>
  );
};
// Report renderer
const RolesEngagementReport = () => {
  const featureName = "Roles Engagement Report";
  const accessibleFeatures = getFromLS('active-features')

  // Check for access else return no access modal
  const [noAccessModalShow, setNoAccessModalShow]=useState(false)
  // if(!accessibleFeatures.includes(featureName)){
  //   return(
  //     <NoAccessPopup 
  //     featurename={featureName}
  //     />
  //   )
  // }

  // declare default grid params
  const [rowData, setRowData] = useState([]);
  const [colDefs, setColDefs] = useState([]);

  // set or declare default report variables
  const [firm_id, setFirmId] = useState(getFromLS("firmId"));

  // This report is specifically only for XCM

  const [vendor, setVendor] = useState("xcm");
  const [totalTasks, setTotalTasks] = useState();
  const [reportDate, setReportDate] = useState();
  const [hoursRemaining, setHoursRemaining] = useState();
  const [columnChartData1, setColumnChartData1] = useState([]);
  const [columnChartData2, setColumnChartData2] = useState([]);
  const [loaderText, setLoaderText] = useState(false);
  // set default API params
const [reportApiResponse, setReportApiResponse] = useState({ "data": { "0": { "report": { "table_data": [] } } } });
// set local mode params
const [localApiResponse, setLocalApiResponse] = useState({
  data: { 0: { report: { staff: [] } } },
});
const [template_file_list, setTemplateFileList] = useState([]);
const [templateDescription, setTemplateDescription] = useState("")
const [localMode, setLocalMode] = useState(false);
const [localLoaderToggle, setLocalLoaderToggle] = useState(true);


/**
 * In this functionm, we pass the API response to extract template links to be displayed in local mode.
 * @param {*} result: API response.
 * @returns API response (for further use).
 */
const setTemplateFiles = (result) => {
  const templates = result.data[0].report.templates
    setTemplateFileList(templates)
    const templateDescriptionHolder = []
    for(let template in templates){
      Object.assign(templateDescriptionHolder, {[templates[template].name + templates[template].extension]: templates[template].description})
    }
    setTemplateDescription(templateDescriptionHolder)
  return result
}

/**
 * This function enables the local mode and maintains the state of loaders and messages to be displayed.
 */
const LocalModeEnabler = () => {
  setLocalLoaderToggle(true);
  if (localMode) {
    console.log("LOCAL MODE API RESPONSE: ", localApiResponse)
    setLoaderText(true);
    setApiData(reportApiResponse, false);
    setLocalLoaderToggle(false);
  }
  setLocalMode(!localMode);
};

const filesMap = {
  "TemplateTaskDetails": "",
}

/**
 * This function accepts the uploaded template excel files and adds them to the payload for making Local Mode API call
 * @param {*} files 
 * @param {*} filename 
 */
const onFileChange = (files, filename) => {
  console.log("FILENAME: ", filename)
  console.log("FILES: ", files)
  const formData = new FormData();
  if (filename == "TemplateTaskDetails") {
    filesMap.TemplateTaskDetails = files[0]
  } 
  console.log("FILES: ", filesMap)
  if (filesMap.TemplateTaskDetails != "") {
    formData.append("file1", filesMap.TemplateTaskDetails);
    LocalModeApi(formData)
  } else {
    console.log("File should be uploaded for making local mode api call.")
  }
};

/**
 * This function takes the payload of uploaded excel files and makes the Local Mode API call
 * @param {*} formData: Payload.
 */
const LocalModeApi = (formData) => {
  // updating payload for Local Mode API
  formData.append("report_name", "roles_engagement");
  // This times out the loader till charts are generated
  // if(formData){
  //   setLoaderText(!loaderText);
  //   setTimeout(() => {
  //     setLocalLoaderToggle(false);
  //   }, 3000);
  // }
  // call api and get data
  const requestOptions = {
    method: "POST",
    body: formData,
  };
  console.log("REQUEST OPTIONS: ", requestOptions);
  fetch(
    `${process.env.REACT_APP_BASE_URI}/api/local/get_reports/`,
    requestOptions
  )
    // API data recieved
    .then((result) => result.json())
    // Local Mode API data state maintained
    .then((result) => {
      if (!result.ok) {
        throw new Error(result.statusText);
      }
      console.log("LOCAL MODE API: ", result)
    if(result.success===true){
      setLoaderText(!loaderText);
      setApiData(result, true)
      setTimeout(() => {
        setLocalLoaderToggle(false);
      }, 3000);
    }else{
      console.log("FAILED TO LOAD A LOCAL FILE!")
      setLocalLoaderToggle(true);
    }
  }
    ).catch(error => {
      console.error('ERROR IN LOCAL MODE API:', error);
    })
}

 // maitain api response
 const setApiData = (result, localMode = false) => {
  console.log("API DATA: ", result)
  if (localMode) {
    setLocalApiResponse(result);
    setMeanColumnChartData(result)
    
  } else {
    setReportApiResponse(result);
    setMeanColumnChartData(result)
  }
  gridParamsMapper(result)
  return result;
};

  /**
   * This function is used for formatting the default column names of the grid
   * @param {*} defaultName: Current name from API
   * @returns: Final column name
   */
  const GridColumnTitleRenderer = (defaultName) => {
    const splitWords = defaultName.split("_")
    for (let word in splitWords) {
      splitWords[word] = splitWords[word].charAt(0).toUpperCase() + splitWords[word].slice(1)
    }
    return splitWords.join(" ")
  }

  /**
   * This function takes the API response data and maps it to the grid params
   * @param {*} result: API response
   */
  const gridParamsMapper = (result) => {
    console.log("GRID PARAM MAPPER RESULT:", result)
    if(result.data[0].report.report.length!=0){
    const keys = Object.keys(result.data[0].report.report[0]) // You need to change this based on API response format in every report
    let jsonColDefs = keys.map(key => {
      return {
        field: key, headerName: GridColumnTitleRenderer(key)
      }
    });
    setColDefs(jsonColDefs)}
    setRowData(result.data[0].report.report);
  }

  const [isLoading, setIsLoading] = useState(true);
  const [categories, setCategories] = useState([
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ]);
  const localChartTheme = getFromLS("chart-theme");

  let setMeanColumnChartData = (result) => {
    const table_data = result.data[0].report.report;
    const cats = [];
    const reviewer_actual = [];
    const preparer_actual = [];
    const client_manager_actual = [];
    const signer_actual = [];
    const engagement_manager_actual = [];
    const reviewer_budget = [];
    const preparer_budget = [];
    const client_manager_budget = [];
    const signer_budget = [];
    const engagement_manager_budget = [];

    for (let key in table_data) {
      const val = table_data[key];
      cats.push(val.month);
      reviewer_actual.push(val.actual_reviewer_mean);
      preparer_actual.push(val.actual_preparer_mean);
      client_manager_actual.push(val.actual_clientmanager_mean);
      signer_actual.push(val.actual_signer_mean);
      engagement_manager_actual.push(val.actual_engagementmanager_mean);
      reviewer_budget.push(val.budget_reviewer_mean);
      preparer_budget.push(val.budget_preparer_mean);
      client_manager_budget.push(val.budget_clientmanager_mean);
      signer_budget.push(val.budget_signer_mean);
      engagement_manager_budget.push(val.budget_engagementmanager_mean);
    }
    setCategories(cats);
    const data = [
      {
        name: "Actual",
        data: preparer_actual,
        stack: "Preparer",
      },
      {
        name: "Budget",
        data: preparer_budget,
        stack: "Preparer",
      },
      {
        name: "Actual",
        data: reviewer_actual,
        stack: "Reviewer",
      },
      {
        name: "Budget",
        data: reviewer_budget,
        stack: "Reviewer",
      },
      {
        name: "Actual",
        data: signer_actual,
        stack: "Signer",
      },
      {
        name: "Budget",
        data: signer_budget,
        stack: "Signer",
      },
      {
        name: "Actual",
        data: engagement_manager_actual,
        stack: "E. Manager",
      },
      {
        name: "Budget",
        data: engagement_manager_budget,
        stack: "E. Manager",
      },
      {
        name: "Actual",
        data: client_manager_actual,
        stack: "C. Manager",
      },
      {
        name: "Budget",
        data: client_manager_budget,
        stack: "C. Manager",
      },
    ];
    setSumColumnChartData(result);
    setColumnChartData1(data);
    const hoursRemaining = result.data[0].report.hours_remaining_in_busy_season;
    const reportDate = result.data[0].report.report_date;
    const totaltasks = result.data[0].report.total_tasks;
    setReportDate(reportDate);
    setHoursRemaining(hoursRemaining);
    setTotalTasks(totaltasks);
    setRowData(result.data[0].report.grid)
    return result.data[0].report.grid;
  };

  let setSumColumnChartData = (result) => {
    const table_data = result.data[0].report.report;
    const reviewer_actual = [];
    const preparer_actual = [];
    const client_manager_actual = [];
    const signer_actual = [];
    const engagement_manager_actual = [];
    const reviewer_budget = [];
    const preparer_budget = [];
    const client_manager_budget = [];
    const signer_budget = [];
    const engagement_manager_budget = [];

    for (let key in table_data) {
      const val = table_data[key];
      reviewer_actual.push(val.actual_reviewer_sum);
      preparer_actual.push(val.actual_preparer_sum);
      client_manager_actual.push(val.actual_clientmanager_sum);
      signer_actual.push(val.actual_signer_sum);
      engagement_manager_actual.push(val.actual_engagementmanager_sum);
      reviewer_budget.push(val.budget_reviewer_sum);
      preparer_budget.push(val.budget_preparer_sum);
      client_manager_budget.push(val.budget_clientmanager_sum);
      signer_budget.push(val.budget_signer_sum);
      engagement_manager_budget.push(val.budget_engagementmanager_sum);
    }
    const data = [
      {
        name: "Actual",
        data: preparer_actual,
        stack: "Preparer",
      },
      {
        name: "Budget",
        data: preparer_budget,
        stack: "Preparer",
      },
      {
        name: "Actual",
        data: reviewer_actual,
        stack: "Reviewer",
      },
      {
        name: "Budget",
        data: reviewer_budget,
        stack: "Reviewer",
      },
      {
        name: "Actual",
        data: signer_actual,
        stack: "Signer",
      },
      {
        name: "Budget",
        data: signer_budget,
        stack: "Signer",
      },
      {
        name: "Actual",
        data: engagement_manager_actual,
        stack: "E. Manager",
      },
      {
        name: "Budget",
        data: engagement_manager_budget,
        stack: "E. Manager",
      },
      {
        name: "Actual",
        data: client_manager_actual,
        stack: "C. Manager",
      },
      {
        name: "Budget",
        data: client_manager_budget,
        stack: "C. Manager",
      },
    ];
    setColumnChartData2(data);
    setIsLoading(false);
  };

  // fetch data from Roles Engagement Report API
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ firm_id, vendor }),
  };

  let gridApi;
  const onGridReady = useCallback((params) => {
    gridApi = params.api;
    gridApi.closeToolPanel();
    fetch(
      `${process.env.REACT_APP_BASE_URI}/api/report/role_engagement/`,
      requestOptions
    )
      // API data recieved
      .then((response) => {
        if (!response.ok) {
          if (response.status === 401) {
            // Handle unauthorized error
            logout();
            alert("Session ended , Please login back");
          } else {
            throw new Error("Request failed.");
          }
        }
        return response.json();
      })
      .then((result) => setApiData(result))
      .then((result) => (setTemplateFiles(result)))
  }, []);


  // grid export functionality
  const onBtExcelExport = useCallback(() => {
    gridApi.exportDataAsExcel();
  }, []);

  const onBtCSVExport = useCallback(() => {
    gridApi.exportDataAsCsv();
  }, []);

  // interactive primary chart
  const primaryOptions = {
    chart: {
      type: "column",
      height: 600,
    },
    subtitle: {
      align: "center",
      text: "Roles engagement",
    },
    title: {
      align: "center",
      text: "Average",
    },
    accessibility: {
      announceNewData: {
        enabled: true,
      },
    },
    colors: localChartTheme.colors,
    xAxis: {
      type: "category",
      categories: categories,
      min: 0,
      max: 2,
      offset: 25,
      tickWidth: 2,
      tickLength: 10,
    },
    scrollbar: {
      enabled: true,
    },

    yAxis: {
      title: {
        text: "Hours",
      },
      stackLabels: {
        enabled: true,
        verticalAlign: "bottom",
        crop: false,
        overflow: "none",
        y: 23,
        formatter: function () {
          return this.stack;
        },
        style: {
          fontSize: "5.5px",
        },
      },
    },
    legend: {
      labelFormatter: function () {
        if (this.userOptions.stack == "E. Manager") {
          return "Engagement Manager" + " (" + this.name + ")";
        }
        if (this.userOptions.stack == "C. Manager") {
          return "Client Manager" + " (" + this.name + ")";
        } else {
          return this.userOptions.stack + " (" + this.name + ")";
        }
      },
    },
    plotOptions: {
      column: {
        stacking: "normal",
        groupPadding: 0.1,
        pointPadding: 0.1,
      },
    },

    tooltip: {
      headerFormat: '<span style="font-size: var(--default)">{series.name}</span><br>',
      pointFormat:
        '<span style="color:{point.color}">{point.name}</span>: <b>{point.y:,.0f}</b> of total<br/>',
    },
    exporting: {
      enabled: true,
      chartOptions: {
        xAxis: [
          {
            max: null,
          },
        ],
      },
    },
    series: columnChartData1,
  };

  const secondaryOptions = {
    chart: {
      type: "column",
      height: 600,
    },
    subtitle: {
      align: "center",
      text: "Roles engagement",
    },
    title: {
      align: "center",
      text: "Sum",
    },
    accessibility: {
      announceNewData: {
        enabled: true,
      },
    },
    colors: localChartTheme.colors,
    xAxis: {
      type: "category",
      categories: categories,
      min: 0,
      max: 2,
      offset: 25,
      tickWidth: 2,
      tickLength: 10,
    },
    scrollbar: {
      enabled: true,
    },

    yAxis: {
      title: {
        text: "Hours",
      },
      stackLabels: {
        enabled: true,
        verticalAlign: "bottom",
        crop: false,
        overflow: "none",
        y: 23,
        formatter: function () {
          return this.stack;
        },
        style: {
          fontSize: "5.5px",
        },
      },
    },
    legend: {
      labelFormatter: function () {
        if (this.userOptions.stack == "E. Manager") {
          return "Engagement Manager" + " (" + this.name + ")";
        }
        if (this.userOptions.stack == "C. Manager") {
          return "Client Manager" + " (" + this.name + ")";
        } else {
          return this.userOptions.stack + " (" + this.name + ")";
        }
      },
    },
    plotOptions: {
      column: {
        stacking: "normal",
        groupPadding: 0.1,
        pointPadding: 0.1,
      },
    },

    tooltip: {
      headerFormat: '<span style="font-size: var(--default)">{series.name}</span><br>',
      pointFormat:
        '<span style="color:{point.color}">{point.name}</span>: <b>{point.y:,.0f}</b> of total<br/>',
    },
    exporting: {
      enabled: true,
      chartOptions: {
        xAxis: [
          {
            max: null,
          },
        ],
      },
    },

    series: columnChartData2,
  };

  const loader = columnChartData1 !=[] && totalTasks && hoursRemaining && reportDate && totalTasks &&  columnChartData2!=[]

  useEffect(() => {
    if (loader) {
      setIsLoading(false);
      setTimeout(() => {
        setLocalLoaderToggle(false);
        setLoaderText(true);
      }, 2000);
    }
  }, [loader]);
  

  const ScreenLoader = () => {
    return (
      <div>
        <div className="spinner">
          <ThreeCircles
            height="100"
            width="100"
            color=""
            wrapperStyle={{}}
            wrapperClass=""
            visible={true}
            ariaLabel="three-circles-rotating"
            outerCircleColor="var(--theme1_primary)"
            innerCircleColor="var(--theme1_secondary)"
            middleCircleColor="var(--theme1_tertiary)"
          />
          <h5
            style={{
              position: "relative",
              left: "-35%",
              padding: "10px",
            }}
          >
            Loading your details of billable and non-billable hours
          </h5>
        </div>
      </div>
    );
  };

  return (
    <>
      <div className="row-wrapper">
        <div className="row-container">
        {localMode ? (
            <>
              <h3 className="intelligence-report-name">{featureName}</h3>
              <Row className="local-import-row">
              <Col md={2} style={{ paddingLeft: 0, paddingRight: 0 }}>
                  <p style={{ color: "#000", fontWeight: "900", marginBottom: 10, marginRight: 20 }}> Download templates
                    <TemplateDescriptionPopover 
                      description={templateDescription}
                    />
                  </p>
                  <Row className="no-gutter">
                    {
                      template_file_list && template_file_list.map((object, index) => (
                        <TemplateDownloadRenderer info={object} key={index} />
                      )
                      )
                    }
                  </Row>
                </Col>
                {
                  template_file_list && template_file_list.map((object, index) => (
                    object.send_back
                      ?
                      <Col md={10} key={index}>
                        <DropFileInput onFileChange={(files) => onFileChange(files, object.name)} message={`Drag and drop ${object.name + "." + object.extension} file here`} />
                      </Col>
                      :
                      <></>
                  )
                  )
                }
              </Row>
            </>
          ) : (
            <>
        <h3 className="intelligence-report-name">{featureName}</h3>
          <Row className="report-card-row">
            <div className="report-card">
              <div className="chip-header">Total tasks</div>
              <div className="chip-body">{totalTasks}</div>
            </div>
            <div className="report-card">
              <div className="chip-header">Hours remaining</div>
              <div className="chip-body">{hoursRemaining}</div>
            </div>
            <div className="report-card">
              <div className="chip-header">Report date</div>
              <div className="chip-body">{reportDate}</div>
            </div>
          </Row>
          </>
          )}
        </div>
      </div>

      <div className="row-wrapper">
        <div className="row-container">
          <Tabs
            defaultActiveKey="chart"
            id="uncontrolled-tab-example"
            className="mb-3"
          >
            <Tab eventKey="chart" title="Chart" className="tabs">
            <OffCanvasNavbar 
                localtoggle = {
                <ButtonGroup>
                  <div className="toggler">
                    {localMode ? (
                      <p style={{ color: "#000", fontWeight: "500" }}>
                        Go back online
                      </p>
                    ) : (
                      <p style={{ color: "#000", fontWeight: "500" }}>
                        Switch to local mode
                      </p>
                    )}
                  </div>
                  <div className="toggler">
                    <Switch
                      isToggled={localMode}
                      onClick={() => LocalModeEnabler()}
                    ></Switch>
                  </div>
                </ButtonGroup>
              }
              />
              
              <Row>
                <Col md="12">
                {localLoaderToggle ? (
                    <div className="chart-container chart-loader">
                      <ThreeCircles
                        height="300"
                        width="300"
                        color=""
                        wrapperStyle={{}}
                        wrapperClass=""
                        visible={true}
                        ariaLabel="--theme1_primary"
                        outerCircleColor="var(--theme1_primary)"
                        innerCircleColor="var(--theme1_tertiary)"
                        middleCircleColor="var(--theme1_quarternary)"
                      />
                      <br />
                      {loaderText ? (
                        <h5
                          style={{
                            position: "relative",
                            padding: "10px",
                          }}
                        >
                          Waiting for you to upload an excel file!
                        </h5>
                      ) : (
                        <h5
                          style={{
                            position: "relative",
                            padding: "10px",
                          }}
                        >
                          Loading your chart!
                        </h5>
                      )}
                    </div>
                  ) : (
                  <div className="chart-container">
                      <HighchartsReact
                        highcharts={Highcharts}
                        options={primaryOptions}
                      />
                  </div>
                  )}
                </Col>
              </Row>
              <Row>
                <Col md="12">
                {localLoaderToggle ? (
                    <div className="chart-container chart-loader">
                      <ThreeCircles
                        height="300"
                        width="300"
                        color=""
                        wrapperStyle={{}}
                        wrapperClass=""
                        visible={true}
                        ariaLabel="--theme1_primary"
                        outerCircleColor="var(--theme1_primary)"
                        innerCircleColor="var(--theme1_tertiary)"
                        middleCircleColor="var(--theme1_quarternary)"
                      />
                      <br />
                      {loaderText ? (
                        <h5
                          style={{
                            position: "relative",
                            padding: "10px",
                          }}
                        >
                          Waiting for you to upload an excel file!
                        </h5>
                      ) : (
                        <h5
                          style={{
                            position: "relative",
                            padding: "10px",
                          }}
                        >
                          Loading your chart!
                        </h5>
                      )}
                    </div>
                  ) : (
                  <div className="chart-container">
                      <HighchartsReact
                        highcharts={Highcharts}
                        options={secondaryOptions}
                      />
                  </div>
                  )}
                </Col>
              </Row>
            </Tab>
            <Tab eventKey="grid" title="Grid" className="tabs">
              <DropdownButton
                as={ButtonGroup}
                className="reset-button download-excel"
                title=" Export"
                id="bg-nested-dropdown"
                drop="start"
              >
                <Dropdown.Item onClick={onBtExcelExport}>
                  {" "}
                  <Icon.FileExcel /> Excel Export
                </Dropdown.Item>
                <Dropdown.Item onClick={onBtCSVExport}>
                  {" "}
                  <Icon.FiletypeCsv /> CSV Export
                </Dropdown.Item>
              </DropdownButton>
              <Row>
                <Col md="12" className="grid-row staffing">
                <ReportGrid
                    rowData={rowData}
                    colDefs={colDefs}
                    onGridReady={onGridReady}
                  />
                </Col>
              </Row>
            </Tab>
          </Tabs>
        </div>
      </div>
    </>
  );
};

export default RolesEngagementReport;
